import React, { Fragment, Component } from 'react';
import { Link } from 'react-router-dom';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Header from './../../Layout/Header';
import FooterPremium from './../../Layout/FooterPremium';
// Images
import banner1 from './../../../images/banner/banner1.png';
import banner2 from './../../../images/banner/img1.jpg';
import banner3 from './../../../images/banner/img3.jpg';
import towera from './../../../images/banner/towera.png';
import towerb from './../../../images/banner/towerb.png';
import main1 from './../../../images/banner/img1.jpg';
import main2 from './../../../images/banner/img2.jpg';
import main3 from './../../../images/banner/img3.jpg';

// Register GSAP plugins
if (typeof window !== 'undefined') {
	gsap.registerPlugin(ScrollTrigger);
}

class Index4 extends Component {
	componentDidMount() {
		// Initialize GSAP animations
		this.initAnimations();
	}

	initAnimations = () => {
		// Hero text animation
		const heroTl = gsap.timeline({ defaults: { ease: 'power3.out' } });
		heroTl
			.from('.hero-title-line-1', { 
				duration: 1.2, 
				y: 100, 
				opacity: 0,
				rotationX: -90,
				transformOrigin: '50% 50% -50'
			})
			.from('.hero-title-line-2', { 
				duration: 1.2, 
				y: 100, 
				opacity: 0,
				rotationX: -90,
				transformOrigin: '50% 50% -50'
			}, '-=0.8')
			.from('.hero-subtitle', { 
				duration: 1, 
				y: 50, 
				opacity: 0 
			}, '-=0.5')
			.from('.hero-cta', { 
				duration: 0.8, 
				scale: 0.8, 
				opacity: 0 
			}, '-=0.3');

		// Parallax effect for hero background
		gsap.to('.hero-background', {
			yPercent: -50,
			ease: 'none',
			scrollTrigger: {
				trigger: '.hero-section',
				start: 'top top',
				end: 'bottom top',
				scrub: true
			}
		});

		// Smooth scroll reveal animations
		const sections = document.querySelectorAll('.animate-section');
		sections.forEach((section, index) => {
			gsap.from(section, {
				scrollTrigger: {
					trigger: section,
					start: 'top 80%',
					end: 'top 20%',
					toggleActions: 'play none none reverse'
				},
				duration: 1.2,
				y: 80,
				opacity: 0,
				ease: 'power3.out',
				delay: index * 0.1
			});
		});

		// Number counter animation
		const counters = document.querySelectorAll('.counter-number');
		counters.forEach(counter => {
			const target = parseInt(counter.getAttribute('data-target'));
			const duration = 2;
			const increment = target / (duration * 60);
			let current = 0;

			ScrollTrigger.create({
				trigger: counter,
				start: 'top 80%',
				onEnter: () => {
					const updateCounter = () => {
						if (current < target) {
							current += increment;
							counter.textContent = Math.floor(current);
							requestAnimationFrame(updateCounter);
						} else {
							counter.textContent = target;
						}
					};
					updateCounter();
				}
			});
		});

		// Image reveal animations
		gsap.utils.toArray('.reveal-image').forEach((img, index) => {
			gsap.from(img, {
				scrollTrigger: {
					trigger: img,
					start: 'top 85%'
				},
				duration: 1.5,
				scale: 1.2,
				opacity: 0,
				ease: 'power3.out',
				delay: index * 0.15
			});
		});

		// Text split animation
		gsap.utils.toArray('.split-text').forEach(text => {
			const words = text.textContent.split(' ');
			text.innerHTML = words.map(word => `<span class="word">${word}</span>`).join(' ');
			
			gsap.from(text.querySelectorAll('.word'), {
				scrollTrigger: {
					trigger: text,
					start: 'top 85%'
				},
				duration: 0.8,
				y: 50,
				opacity: 0,
				stagger: 0.05,
				ease: 'power3.out'
			});
		});

		// Floating animation for cards
		gsap.utils.toArray('.float-card').forEach((card, index) => {
			gsap.to(card, {
				y: -20,
				duration: 2 + index * 0.2,
				repeat: -1,
				yoyo: true,
				ease: 'power1.inOut',
				delay: index * 0.3
			});
		});
	}

	render() {
		return (
			<Fragment>
				<Header />
				
				{/* Hero Section */}
				<section className="hero-section">
					<div className="hero-background" style={{ backgroundImage: `url(${banner1})` }}></div>
					<div className="hero-overlay"></div>
					<div className="container">
						<div className="hero-content">
							<h1 className="hero-title">
								<span className="hero-title-line-1">GOLDCREST'S</span>
								<span className="hero-title-line-2">ENDURING LEGACY</span>
							</h1>
							<p className="hero-subtitle split-text">
								Iconic buildings that redefine architecture and luxury living in the heart of the UAE
							</p>
							<div className="hero-cta">
								<Link to="/contact-us" className="btn btn-primary btn-lg">
									<span>Discover The Impossible</span>
									<i className="las la-arrow-right"></i>
								</Link>
							</div>
						</div>
					</div>
					<div className="scroll-indicator">
						<div className="mouse">
							<div className="wheel"></div>
						</div>
					</div>
				</section>

				{/* Stats Section */}
				<section className="stats-section animate-section">
					<div className="container">
						<div className="row">
							<div className="col-md-3 col-sm-6 mb-4">
								<div className="stat-card float-card">
									<div className="stat-number counter-number" data-target="20">0</div>
									<div className="stat-label">Years of Excellence</div>
								</div>
							</div>
							<div className="col-md-3 col-sm-6 mb-4">
								<div className="stat-card float-card">
									<div className="stat-number counter-number" data-target="18">0</div>
									<div className="stat-label">Masterpieces</div>
								</div>
							</div>
							<div className="col-md-3 col-sm-6 mb-4">
								<div className="stat-card float-card">
									<div className="stat-number counter-number" data-target="10">0</div>
									<div className="stat-label">Billion Portfolio</div>
								</div>
							</div>
							<div className="col-md-3 col-sm-6 mb-4">
								<div className="stat-card float-card">
									<div className="stat-number counter-number" data-target="3">0</div>
									<div className="stat-label">Destinations</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* About Section */}
				<section className="about-section animate-section">
					<div className="container">
						<div className="row align-items-center">
							<div className="col-lg-6">
								<div className="about-content">
									<h2 className="section-title split-text">Creating Living Works of Art</h2>
									<p className="section-description">
										Art is more than a symbol of luxury; it's an expression of rarity, creativity, and quality. 
										Our unique masterpieces and destinations are legacies for the future.
									</p>
									<p className="section-description">
										Driven by passion, we continuously push the boundaries of architecture by constructing 
										residential, commercial, hospitality, and retail spaces that frame Dubai's skyline.
									</p>
									<Link to="/about-us" className="btn btn-outline-primary">
										<span>Our Story</span>
										<i className="las la-arrow-right"></i>
									</Link>
								</div>
							</div>
							<div className="col-lg-6">
								<div className="about-image reveal-image">
									<img src={main1} alt="About" />
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* Masterpieces Section */}
				<section className="masterpieces-section animate-section">
					<div className="container">
						<div className="section-header text-center">
							<h2 className="section-title split-text">Masterpieces</h2>
							<p className="section-subtitle">
								Creating living works of art that define luxury and architectural excellence
							</p>
						</div>
						<div className="row">
							<div className="col-lg-4 col-md-6 mb-4">
								<div className="masterpiece-card float-card">
									<div className="card-image reveal-image">
										<img src={towera} alt="Tower A" />
									</div>
									<div className="card-content">
										<h3 className="card-title">Tower A</h3>
										<p className="card-description">
											An architectural marvel that redefines luxury living with world-class amenities and stunning views.
										</p>
										<Link to="/goldcrest-dream-tower-a" className="card-link">
											Explore <i className="las la-arrow-right"></i>
										</Link>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 mb-4">
								<div className="masterpiece-card float-card">
									<div className="card-image reveal-image">
										<img src={towerb} alt="Tower B" />
									</div>
									<div className="card-content">
										<h3 className="card-title">Tower B</h3>
										<p className="card-description">
											Modern elegance meets timeless design in this exceptional residential development.
										</p>
										<Link to="/goldcrest-dream-tower-b" className="card-link">
											Explore <i className="las la-arrow-right"></i>
										</Link>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 mb-4">
								<div className="masterpiece-card float-card">
									<div className="card-image reveal-image">
										<img src={main2} alt="Goldcrest Dreams Tower C" />
									</div>
									<div className="card-content">
										<h3 className="card-title">Goldcrest Dreams Tower C</h3>
										<p className="card-description">
											The pinnacle of luxury living with breathtaking architecture and premium finishes.
										</p>
										<Link to="/goldcrest-dream-tower-c" className="card-link">
											Explore <i className="las la-arrow-right"></i>
										</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* Vision Section */}
				<section className="vision-section animate-section">
					<div className="container">
						<div className="row align-items-center">
							<div className="col-lg-6 order-lg-2">
								<div className="vision-content">
									<h2 className="section-title split-text">Imagining The Impossible</h2>
									<p className="section-description">
										For two decades, we have transformed bold ideas into living works of art, 
										shaping skylines with architectural masterpieces.
									</p>
									<p className="section-description">
										Our journey is shaped by creativity, ambition, and an enduring belief 
										in limitless possibilities.
									</p>
									<div className="vision-features">
										<div className="feature-item">
											<i className="las la-check-circle"></i>
											<span>Innovative Design</span>
										</div>
										<div className="feature-item">
											<i className="las la-check-circle"></i>
											<span>Premium Quality</span>
										</div>
										<div className="feature-item">
											<i className="las la-check-circle"></i>
											<span>Sustainable Living</span>
										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-6 order-lg-1">
								<div className="vision-image reveal-image">
									<img src={main3} alt="Vision" />
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* CTA Section */}
				<section className="cta-section animate-section">
					<div className="container">
						<div className="cta-content text-center">
							<h2 className="cta-title split-text">Discover The Impossible</h2>
							<p className="cta-description">
								Enquire for more details and experience the future of luxury living
							</p>
							<div className="cta-buttons">
								<Link to="/contact-us" className="btn btn-primary btn-lg">
									<span>Request a Callback</span>
									<i className="las la-phone"></i>
								</Link>
								<Link to="/projects" className="btn btn-outline-light btn-lg">
									<span>View All Projects</span>
									<i className="las la-arrow-right"></i>
								</Link>
							</div>
						</div>
					</div>
				</section>

				<FooterPremium />
			</Fragment>
		);
	}
}

export default Index4;

